import React from 'react';
import config from 'Config';
import api from 'Src/api';
import session from 'Src/session';
import titleImgUrl from 'Public/img/reservation-title-inquiry.png';
import titleImg2xUrl from 'Public/img/reservation-title-inquiry@2x.png';
import titleImgSpUrl from 'Public/img/sp-reservation-title-inquiry@2x.png';
import titleImgSp2xUrl from 'Public/img/sp-reservation-title-inquiry@2x.png';
import FormProvider from 'Src/shared/form-provider';
import Contact from 'Src/shared/contact';
import Errors from 'Src/shared/errors';
const { Panel, PanelBody } = Contact;
import { CertificationInquiry } from 'Src/components/form/block';
const path = require('path');

// const scrolltop = () => {
//   window.scrollto(0, 0);
// };

const properties = config.form_properties;
const certProperties = Object.keys(properties).reduce((result, k) => {
  if (/cert/.test(properties[k].func)) {
    result[k] = properties[k];
  }
  return result;
}, {});

class Certification extends FormProvider {
  properties = certProperties;
  functionKey = 'shokai';
  constructor (props) {
    super(props);
    const self = this;
    self.submitForm = self.submitForm.bind(self);
    self.back = self.back.bind(self);
  }
  componentDidMount () {
    const self = this;
    if (super.componentDidMount) {
      super.componentDidMount();
    }
    // 認証情報をクリア
    session.removeCertificate();
    // 個人情報取得に関する同意がされていない場合はトップへ戻る
    //  requiredAgreementKeyをセットしておくことで、トップでモーダルが自動で開く
    if (!session.isAgreed()) {
      session.requireAgreement(self.functionKey);
      window.history.replaceState(null, '', config.path.root);
      window.location.reload();
      return;
    }
  }
  back () {
    window.history.back();
  }
  submitForm () {
    const self = this;
    self
      .validate()
      .then((requestData) => self.remoteCertificate(requestData))
      .then((responseData) => {
        const reservationCode = responseData.reservationCode;
        const token = responseData.token;
        session.setCertificate({ token, reservationCode });
        window.location.href = path.join(config.path.reference, reservationCode);
      })
      .catch(() => {
        session.removeCertificate();
        if (!self.state.errors || self.state.errors.length < 1) {
          self.setState({
            errors: [
              { message: '認証できませんでした。予約番号とメールアドレスが正しいか確認してください。' },
              { message: '一度変更・取消された予約内容は照会できません。' }
            ]
          });
        }
        // scrollTop();
      });
  }
  remoteCertificate (requestData) {
    return api.certificateReservation(requestData);
  }
  sortByName (items) {
    const self = this;
    if (!self.properties) {
      return items;
    }
    const names = Object.keys(self.properties)
      .map((k) => self.properties[k].name)
      .filter((v) => v);
    items.sort((a, b) => {
      return names.indexOf(a.name) - names.indexOf(b.name);
    });
    return items;
  }
  renderForm () {
    const self = this;
    const { errors, readonly } = self.state;
    return (
      <Contact theme="default" readonly={readonly}>
        <div className="mb-3">
          <picture>
            <source srcSet={`${titleImgSpUrl} 1x, ${titleImgSp2xUrl} 2x`} media="(max-width: 575px)" />
            <img
              src={titleImgUrl}
              srcSet={`${titleImgUrl} 1x, ${titleImg2xUrl} 2x`}
              alt="水道使用 開始・中止の予約照会・変更・取消"
              className="img-fluid w-100"
            />
          </picture>
        </div>
        <p className="text-md-center">
          インターネットから予約をした使用開始・使用中止情報の照会・変更・取消ができます。
        </p>
        <div className="border-top">
          <Panel theme="optional">
            <PanelBody>
              <div className="d-flex flex-column flex-xl-row py-3">
                <div className="flex-fill">
                  <ul className="mb-0">
                    <li className="mb-3">
                      一度変更された場合、変更前の予約内容は照会できません。また取消された予約内容も照会できませんので、再度お申込ください。
                    </li>
                    <li>期間を経過すると、照会・変更・取消ができない場合がございます。</li>
                  </ul>
                </div>
              </div>
            </PanelBody>
          </Panel>
        </div>
        {errors && errors.length >= 1 && <Errors errors={errors} />}
        <Panel title="特定するための情報" theme="secondary">
          <CertificationInquiry />
        </Panel>
        <div className="btn-toolbar justify-content-between p-2">
          <button type="button" className="btn btn-secondary px-md-5" tabIndex={-1} onClick={self.back}>
            <strong>キャンセル</strong>
          </button>
          <button type="button" className="btn btn-primary px-md-5" onClick={self.submitForm}>
            <strong>照会</strong>
          </button>
        </div>
      </Contact>
    );
  }
}

export default Certification;
